module.exports = __webpack_public_path__ + "files/c68e09d8ed08a656b7f2301f027dd633.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-italic-webfont.ttf
// module id = 814
// module chunks = 60